'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAgentResponder = fetchAgentResponder;

var _noAuthApiClient = require('../../http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchAgentResponder(_ref) {
  var senderId = _ref.senderId,
      agentType = _ref.agentType;

  var portalId = _hubspot2.default.get();

  return _noAuthApiClient2.default.get('messages/v2/message/agents/' + senderId, {
    query: { agentType: agentType, portalId: portalId }
  });
}


//////////////////
// WEBPACK FOOTER
// ./js/responders/clients/fetchAgentResponder.js
// module id = 591
// module chunks = 2 3